import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Input, Button, Flex } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import styles from './submit-application-modal.module.scss';

const { TextArea } = Input;

/**
 * SubmitApplicationModal
 *
 * Modal for submitting applications for a lead to schools.
 *
 * @param {Object} props - Component properties
 * @param {boolean} props.open - Whether the modal is visible
 * @param {function} props.onClose - Function to close the modal
 */
export const SubmitApplicationModal = ({ open, onClose }) => {
  const { selectedLead } = useSelector((state) => state.spot);
  const [searchValue, setSearchValue] = useState('');
  const [applicationNote, setApplicationNote] = useState('');

  const handleSearch = (value) => {
    setSearchValue(value);
    // Here you would typically implement a search function
  };

  const handleSubmit = () => {
    // Here you would implement the submission logic
    console.log('Submitting application with note:', applicationNote);
    onClose();
  };

  const leadName = selectedLead ? `${selectedLead.parent_first_name} ${selectedLead.parent_last_name}` : '';
  const leadId = selectedLead?.id || '';

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      className={styles.submitApplicationModal}
      title={`Submit Applications for ${leadName} ${leadId}`}
      centered>
      <div className={styles.modalContent}>
        <div className={styles.searchSection}>
          <h3 className={styles.sectionTitle}>Search for Additional Schools</h3>
          <Flex gap="middle" className={styles.searchInputContainer}>
            <Input
              placeholder="Search by school name, ID, city, or state..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className={styles.searchInput}
              size="large"
            />
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="large"
              onClick={() => handleSearch(searchValue)}
              className={styles.searchButton}>
              Search
            </Button>
          </Flex>
        </div>

        <div className={styles.noteSection}>
          <h3 className={styles.sectionTitle}>Application Note</h3>
          <TextArea
            placeholder="Add a note about this application submission..."
            value={applicationNote}
            onChange={(e) => setApplicationNote(e.target.value)}
            className={styles.noteTextarea}
            rows={30}
          />
        </div>

        <div className={styles.actionSection}>
          <Button type="primary" size="large" onClick={handleSubmit} className={styles.submitButton}>
            Submit Selected Applications
          </Button>
        </div>
      </div>
    </Modal>
  );
};

SubmitApplicationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
